import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/hocs/TranslationsProvider/TranslationsProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["logError"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/services/DatadogService/DatadogService.ts");
;
import(/* webpackMode: "eager", webpackExports: ["HomePageTemplate"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/templates/HomePageTemplate/HomePageTemplate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LegacyHomePageTemplate"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/templates/HomePageTemplate/LegacyHomePageTemplate.tsx");
